import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import {
  DiversionsPreviousRequestsActions,
  DiversionsPreviousRequestsSelectors,
  fromDiversionsPreviousRequests
} from '@ruby/modules/diversions/store/diversions-previous-requests.index';
import {
  IDiversionsCustomerDetails,
  IDiversionsPreviousRequestFilters,
  IDiversionsPrevReqPayload
} from '@ruby/shared/models/diversions/diversions.interface';

@Component({
  selector: 'ng-previous-requests-form-container',
  templateUrl: './previous-requests.container.html',
  styleUrls: ['./previous-requests.container.scss']
})
export class PreviousRequestsFormContainer {
  store$: Observable<{
    state: fromDiversionsPreviousRequests.State;
    selectedCustomerDetails?: Partial<IDiversionsCustomerDetails>;
    internalRole?: boolean;
  }>;
  keepFilters = false;

  constructor(private store: Store<fromDiversionsPreviousRequests.State>, private router: Router) {
    this.parseKeepFilters();
    this.loadStatusAndRequestList();
    this.store$ = this.store.select(DiversionsPreviousRequestsSelectors.selectDiversionsPrevRequestsFormState);
  }

  /**
   * submit Form
   *
   * @summary submit previous requests form
   * @param $payload: IDiversionsPrevReqPayload
   * @returns void
   */
  submitForm($payload: IDiversionsPrevReqPayload): void {
    this.store.dispatch(DiversionsPreviousRequestsActions.loadPreviousRequests({ data: $payload }));
  }

  /**
   * Save Filters
   *
   * @summary Dispatch save filters action
   * @params $form: IDiversionsPreviousRequestFilters
   * @returns void
   */
  saveFilters($form: IDiversionsPreviousRequestFilters): void {
    this.store.dispatch(DiversionsPreviousRequestsActions.saveFilters({ data: { filters: $form } }));
  }

  /**
   * Reset State
   *
   * @summary Dispatch reset state action
   * @returns void
   */
  resetState(): void {
    this.store.dispatch(DiversionsPreviousRequestsActions.resetState());
  }

  private parseKeepFilters(): void {
    const state: { keepFilters: boolean } | undefined = this.router.getCurrentNavigation()?.extras.state as {
      keepFilters: boolean;
    };
    this.keepFilters = state?.keepFilters;

    if (!this.keepFilters) {
      this.store.dispatch(DiversionsPreviousRequestsActions.resetFilters());
    }
  }

  private loadStatusAndRequestList(): void {
    this.store.dispatch(DiversionsPreviousRequestsActions.loadStatusAndRequestType());
  }
}
